import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { appTitle } from "../common/GeneralConfigurations";
import CompanyPageForm from "./CompanyPageForm";
import {
  addCompany,
  deleteCompany,
  getCompanies,
  updateCompany,
} from "../../api/CompanyApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";

const ManageCompanyListPage = () => {
  const [loading, setLoading] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [event, setEvent] = useState("");
  const [companyHandler, setCompanyHandler] = useState({});
  useEffect(() => {
    document.title = `${appTitle} - Company List`;
  }, []);

  useEffect(() => {
    getCompanyData();
  }, []);
  const getCompanyData = () => {
    getCompanies().then((res) => {
      if (res.status == 200) {
        setCompanyData(res.data);
        setLoading(false);
      } else {
        AdnMessageError("Failed to load data");
        setLoading(false);
      }
    });
  };
  const submitCompany = (values) => {
    if (event == "add") {
      addCompany(values).then((res) => {
        if (res.status == 201) {
          AdnMessageSuccess();
          getCompanyData();
          setVisible(false);
        } else {
          AdnMessageError();
        }
      });
    } else if (event == "edit") {
      values.id = companyHandler.id;
      updateCompany(values).then((res) => {
        if (res.status == 200) {
          AdnMessageSuccess();
          getCompanyData();
          setVisible(false);
        } else {
          AdnMessageError();
        }
      });
    }
  };
  const deleteRecord = (id) => {
    deleteCompany(id).then((res) => {
      if (res.status == 200) {
        AdnMessageSuccess();
        getCompanyData();
      } else {
        AdnMessageError();
      }
    });
  };
  return (
    <>
      <CompanyPageForm
        loading={loading}
        companyData={companyData}
        visible={visible}
        setVisible={setVisible}
        event={event}
        submitCompany={submitCompany}
        setEvent={setEvent}
        deleteRecord={deleteRecord}
        setCompanyHandler={setCompanyHandler}
      />
    </>
  );
};

export default ManageCompanyListPage;
